import { apiSlice } from 'store/api/apiSlice';
import { UserProps } from 'store/user/user.types';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfileAndRoles: builder.query<UserProps, void>({
      query: () => `/auth/user-profile`,
      transformResponse: (response: { data: UserProps }) => response.data
    })
  })
});

export const { useLazyGetUserProfileAndRolesQuery } = authApi;
